import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import styled from 'styled-components';
import { Formik, Field, Form } from 'formik';
import { Box, Button, Text } from '@components/common';
import SvgIcon from '@components/SvgIcon';
import { DateField } from '@components/form';

import validationSchema from './schema';
import MoveoutActions, { MoveoutSelectors } from '@redux/MoveoutRedux';

const LockIcon = styled(SvgIcon)`
  position: absolute;
  right: 12px;
  top: 20px;
`;

const today = new Date();

class MoveDateForm extends React.Component {
  static propTypes = {
    setRangeInfo: PropTypes.func,
    onSubmit: PropTypes.func,
    onCancel: PropTypes.func,
    initialFormValues: PropTypes.object
  };

  handleSubmit = async values => {
    const { onSubmit, setRangeInfo } = this.props;
    setRangeInfo(values);
    onSubmit(values);
  };

  renderLockIcon = () => {
    return <LockIcon name="lock" width={16} height={16} />;
  };

  render() {
    const { initialFormValues } = this.props;

    return (
      <Formik
        initialValues={initialFormValues}
        onSubmit={this.handleSubmit}
        validationSchema={validationSchema}
        initialErrors={validationSchema.isValidSync(initialFormValues)}
        validateOnChange
      >
        {({ isSubmitting }) => {
          return (
            <Form>
              <Box display="flex" flexDirection="column">
                <Text fontSize={1} mb={4} color="lightText">
                  When does your current lease end?
                </Text>
                <Field
                  component={DateField}
                  mb={4}
                  name="leaseEndDate"
                  type="text"
                  label="yyyy/mm/dd"
                  minDate={today}
                />

                <Text fontSize={1} mb={4} color="lightText">
                  When does your new lease start?
                </Text>
                <Field
                  component={DateField}
                  mb={4}
                  name="leaseStartDate"
                  type="text"
                  label="yyyy/mm/dd"
                  minDate={today}
                />

                <Box flex={1} mb={4} display="flex" flexDirection="row">
                  <Button flex={1} type="submit" disabled={isSubmitting}>
                    Continue
                  </Button>
                </Box>
              </Box>
            </Form>
          );
        }}
      </Formik>
    );
  }
}

const mapStatesToProps = state => ({
  initialFormValues: MoveoutSelectors.selectDateRangeInfo(state)
});

const mapDispatchToProps = dispatch => ({
  setRangeInfo: info => dispatch(MoveoutActions.setMoveoutDateRangeInfo(info))
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(MoveDateForm);
